import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
(function () {
  const w = window as any;
  const d = document;
  if (w.fbq) return;
  const fbq = function (...args: any[]) {
    if ((fbq as any).callMethod) {
      ;
      (fbq as any).callMethod.apply(fbq, args);
    } else {
      ;
      (fbq as any).queue.push(args);
    }
  };
  (fbq as any).push = fbq;
  (fbq as any).loaded = true;
  (fbq as any).version = '2.0';
  (fbq as any).queue = [];
  w.fbq = fbq;
  w._fbq = fbq;
  // Crear script de Facebook
  const script = d.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  // Insertar script
  const firstScript = d.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
  } else {
    d.head.appendChild(script);
  }
  // Inicializar pixel con tu ID
  w.fbq('init', '2020793225485829');
  w.fbq('track', 'PageView');
  // Agregar noscript fallback para usuarios sin JavaScript
  const noscriptImg = d.createElement('img');
  noscriptImg.height = 1;
  noscriptImg.width = 1;
  noscriptImg.style.display = 'none';
  noscriptImg.src = 'https://www.facebook.com/tr?id=2020793225485829&ev=PageView&noscript=1';
  d.body.appendChild(noscriptImg);
})();
// Render de la aplicación React
render(<App data-id="element-248" />, document.getElementById('root'));